module.exports = __webpack_public_path__ + "static/media/info-icon.2ed6bb44.svg";